import styles from './ccf-interaction-search-cases-tab.module.scss';
import {
  CcfBox,
  CcfClipboardCheckIconComponent,
  CcfDeboucedInput,
  CcfDivider,
  CcfInteractionAcdIcon,
  CcfInteractionEmailIcon,
  CcfInteractionSearchChatIcon,
  CcfInteractionSearchColumnIcon,
  CcfInteractionSearchOutboundIcon,
  CcfOverflowIcon,
  CcfPopOver,
  CcfSaveTranscriptIconComponent,
  CcfSendIcon,
  CcfSupervisorFilterIcon,
  CcfTypography,
  CcfUserPlusIconComponent,
  DividerOrientation,
  DividerVariant,
  PopOverMenuItem,
  useTranslator,
} from '@nice-ccf/ui-controls';
import TranslateOutlinedIcon from '@mui/icons-material/TranslateOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { DataGrid } from '@mui/x-data-grid';
import { makeStyles } from '@mui/styles';
import {
  Button,
  Grid,
  InputAdornment,
  Popover,
  useMediaQuery,
} from '@mui/material';
import { Theme, useTheme } from '@mui/material';
import { interactionSearchData } from './ccf-interactionSearch-staticData';
import { Search } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { fomatToDateString, fomatToTimeString } from '@nice-ccf/core-sdk';
import CcfInteractionSearchCasesFilters from './ccf-interaction-search-cases-filters';
import CcfInteractionSearchCasesCheckboxes from './ccf-interaction-search-cases-checkboxes';
import { CcfInteractionSearchCustomizableMenu } from '@nice-ccf/ui-components';
import { useDispatch, useSelector } from 'react-redux';
import {
  ccfInteractionSearchActions,
  getDefaultColumns,
} from '../../ccf-interaction-search.slice';

/* eslint-disable-next-line */
export interface CcfInteractionSearchCasesTabProps {}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      Height: '330px',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',

      color: '#333333',

      /* Inside auto layout */
    },
    // '& .MuiDataGrid-window': {
    //   height: '285px',
    //   overflowY: 'scroll',
    // },
  },
  searchInput: {
    '&.MuiOutlinedInput-input': {
      padding: '5px',
    },
    // '&.MuiOutlinedInput-inputAdornedEnd': {
    //   paddingBottom: '7.5px',
    // },
  },
});

/**
 * Function to handle drawer open close
 * @example renderIconForType()
 */
const renderIconForType = (param: string) => {
  switch (param) {
    case 'email':
      return <CcfInteractionEmailIcon />;
    case 'inbound':
      return <CcfInteractionAcdIcon />;
    case 'outbound':
      return <CcfInteractionSearchOutboundIcon />;
    case 'chat':
      return <CcfInteractionSearchChatIcon />;
    default:
      return '';
  }
};

const dropdownOptions = {
  menuItems: [
    {
      items: [
        {
          label: 'Assign to Me',
          icon: (
            <div style={{ height: '18px' }}>
              <CcfClipboardCheckIconComponent />
            </div>
          ),
        },
        {
          label: 'Consult/Transfer',
          icon: (
            <div style={{ height: '21px' }}>
              <CcfUserPlusIconComponent />{' '}
            </div>
          ),
          dividerEnable: true,
        },
        {
          label: 'Translate Messages',
          icon: (
            <TranslateOutlinedIcon
              style={{ fontSize: '1.1rem', fill: '#333333' }}
            />
          ),
        },
        {
          label: 'Send Transcript',
          icon: (
            <CcfSendIcon style={{ fontSize: '1.1rem' }} fillColor={'#333333'} />
          ),
        },
        {
          label: 'Save Transcript',
          icon: <CcfSaveTranscriptIconComponent />,
          dividerEnable: true,
        },
        {
          label: 'Outcomes',
          icon: (
            <CheckCircleOutlineOutlinedIcon
              style={{ fontSize: '1.4rem', fill: '#007AB8' }}
            />
          ),
        },
      ],
    },
  ],
};

export const columns = [
  {
    field: 'type',
    headerName: 'type'.toUpperCase(),
    maxWidth: 100,
    flex: 1,
    headerClassName: 'gridHeaderText',
    renderCell: (params: any) => {
      const iconType =
        params.value === 'voice' && params.row.voiceDirection === 'inbound'
          ? 'inbound'
          : params.value === 'voice' && params.row.voiceDirection === 'outbound'
          ? 'outbound'
          : params.value;

      return renderIconForType(iconType);
    },
    hide: false,
  },
  {
    field: 'lastUpdated',
    headerName: 'last Updated'.toUpperCase(),
    flex: 1,
    hide: false,
  },
  {
    field: 'status',
    headerName: 'status'.toUpperCase(),
    flex: 1,
    hide: false,
  },
  {
    field: 'customerName',
    headerName: 'Customer Name'.toUpperCase(),
    flex: 1,
    hide: false,
  },
  {
    field: 'skill',
    headerName: 'skill'.toUpperCase(),
    flex: 1,
    renderCell: (params: any) => (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '90%',
        }}
      >
        {params.value}
        <div
          style={{
            margin: '10px 5px',
          }}
          id="agent_interactionSearcg_skill_popoverMenu"
        >
          <CcfPopOver
            onPopOverItemSelection={onPopOverItemSelection}
            optionList={dropdownOptions}
          />
        </div>
      </div>
    ),
    hide: false,
  },
  {
    field: 'inboxAssigneeUser',
    headerName: 'inboxAssignee'.toUpperCase(),
    flex: 1,
    valueGetter: (params: any) => {
      return params?.value ? `${params?.value}` : '';
    },
    sortable: false,
    hide: true,
  },
  {
    field: 'ownerAssigneeUser',
    headerName: 'ownerAssignee'.toUpperCase(),
    flex: 1,
    valueGetter: (params: any) => {
      return params?.value ? `${params?.value}` : '';
    },
    sortable: false,
    hide: true,
  },
  {
    field: 'routingQueuePriority',
    headerName: 'priority'.toUpperCase(),
    flex: 0.5,
    sortable: false,
    hide: true,
  },
  {
    field: 'id',
    headerName: 'caseId'.toUpperCase(),
    flex: 0.5,
    sortable: false,
    hide: true,
  },
];

/**
 * method to trigger click event of popover menuitem
 * @param item -PopOverMenuItem
 * @returns -
 * ```
 * @example
 * onPopOverItemSelection('Show Origin')
 * ```
 */
const onPopOverItemSelection = (item: PopOverMenuItem) => () => {
  console.log('Clicked Menuitem', item);
  if (item.label === '') {
    console.log('Clicked Menuitem');
  }
};

/**
 * CcfInteractionSearch - used to display Notes in contact card
 * @param props -? - CcfInteractionSearchProps
 * @example - <CcfInteractionSearch />
 */
export function CcfInteractionSearchCasesTab(
  props: CcfInteractionSearchCasesTabProps
) {
  const classes = useStyles();
  const [rowData, setRowData]: any = useState([]);
  const [selectedRowData, setSelectedRowData] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [translate] = useTranslator();
  const [updatedRowData, setUpdatedRowData]: any = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  let defaultCols = useSelector(getDefaultColumns);
  // defaultCols = defaultCols.map((col) => {
  //   return {...col, field: translate(col.field)};
  // });
  const theme: Theme = useTheme();
  const dispatch = useDispatch();
  const isSmView = useMediaQuery(theme.breakpoints.down('xl'), { noSsr: true });

  const mobileViewColumns = [
    {
      field: 'type',
      headerName: 'type'.toUpperCase(),
      maxWidth: 100,
      flex: 1,
      headerClassName: 'gridHeaderText',
      renderCell: (params: any) => {
        const iconType =
          params.value === 'voice' && params.row.voiceDirection === 'inbound'
            ? 'inbound'
            : params.value === 'voice' &&
              params.row.voiceDirection === 'outbound'
            ? 'outbound'
            : params.value;

        return renderIconForType(iconType);
      },
      hide: false,
    },
    {
      field: 'lastUpdated',
      headerName: 'last Updated'.toUpperCase(),
      flex: 1,
      hide: false,
    },
    {
      field: 'status',
      headerName: 'status'.toUpperCase(),
      flex: 1,
      hide: false,
    },
    {
      field: '',
      headerName: '',
      flex: 1,
      renderCell: (params: any) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '90%',
          }}
        >
          <div
            style={{
              margin: '10px 5px',
            }}
            id="agent_interactionSearcg_skill_popoverMenu"
          >
            <CcfPopOver
              onPopOverItemSelection={onPopOverItemSelection}
              optionList={dropdownOptions}
            />
          </div>
        </div>
      ),
      hide: false,
    },
  ];

  useEffect(() => {
    const rd = interactionSearchData.data.map((x, i) => {
      const icon = x.channelId.split('_')[0];
      return {
        id: i,
        type: icon,
        lastUpdated:
          `${new Date(x.endUser.updatedAt)}` !== 'Invalid Date'
            ? fomatToDateString(new Date(x.endUser.updatedAt)) +
              ' ' +
              fomatToTimeString(new Date(x.endUser.updatedAt))
            : '',
        status: x.status,
        customerName: `${x.authorEndUserIdentity.firstName} ${x.authorEndUserIdentity.lastName}`,
        skill: x.skill,
        voiceDirection: x.direction,
        inboxAssigneeUser: `${x?.inboxAssigneeUser}`,
        ownerAssigneeUser: `${x?.ownerAssigneeUser}`,
        createdAt: `${x.createdAt}`,
      };
    });
    setRowData(rd);
    setUpdatedRowData(rd);
  }, []);

  const rows = rowData;

  /**
   * method to trigger click event of popover menuitem
   * @param item -PopOverMenuItem
   * @returns -
   * ```
   * @example
   * onPopOverItemSelection('Show Origin')
   * ```
   */
  const handleSelectionChange = (ids: any) => {
    const selectedIDs = new Set(ids);
    const selectedData = rowData.filter((row: any) => selectedIDs.has(row.id));

    setSelectedRowData(selectedData);
    setSelectedIds(ids);
  };

  return (
    <CcfBox
      id={`agent_interactionSearch_cases_tab_container`}
      style={{ height: '100%', width: '100%' }}
    >
      <CcfBox className={styles.tableBlock}>
        <CcfBox className={styles.tableHeader}>
          <CcfBox
            className={styles.searchBoxSection}
            sx={isSmView ? { width: '60%' } : { width: '80%' }}
          >
            <CcfBox className={styles.searchBox}>
              <CcfDeboucedInput
                id="agent_interactionSearch_cases_tab_searchContainer"
                size="small"
                style={{
                  background: 'white',
                }}
                className={classes.searchInput}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search htmlColor="grey" />
                    </InputAdornment>
                  ),
                }}
                placeholder={translate('searchcontent')}
                variant="outlined"
                fullWidth
                delay={1500}
              />
            </CcfBox>
          </CcfBox>

          <CcfInteractionSearchCasesFilters
            rowData={rowData}
            setRowData={setRowData}
            setUpdatedRowData={setUpdatedRowData}
            updatedRowData={updatedRowData}
          />
          <CcfBox
            id={`agent_interactionSearch_cases_tab_customColumns`}
            className={
              !isSmView ? styles.columnIconBlock : styles.columnIconHideBlock
            }
            onClick={(e: React.MouseEvent<HTMLElement>) =>
              dispatch(
                ccfInteractionSearchActions.updateCustomizeMenuElement(
                  e.currentTarget
                )
              )
            }
          >
            <div style={{ height: '18px' }}>
              {isSmView ? (
                <CcfOverflowIcon />
              ) : (
                <CcfInteractionSearchColumnIcon />
              )}
            </div>
            {!isSmView && (
              <CcfTypography
                className={styles.filtersHeader}
                translationKey={'columns'}
              ></CcfTypography>
            )}
          </CcfBox>
          <CcfBox flexDirection="column" height="100%">
            <CcfInteractionSearchCustomizableMenu />
          </CcfBox>
        </CcfBox>
        <CcfBox style={{ height: '495px', overflowY: 'scroll' }}>
          {selectedRowData && selectedRowData.length ? (
            <CcfBox id={`agent_interactionSearch_breadcrumbs_mainContainer`}>
              {' '}
              <CcfInteractionSearchCasesCheckboxes
                selectedRowData={selectedRowData}
                setRowData={setRowData}
                rowData={rowData}
                setSelectedRowData={setSelectedRowData}
                setSelectedIds={setSelectedIds}
                selectedIds={selectedIds}
              />
            </CcfBox>
          ) : null}
          <CcfBox
            style={{
              height: 'inherit',
              backgroundColor: '#FFFF',
              overflowY: 'hidden',
              borderTop: '1px solid #E1E1E1',
            }}
            id={`agent_interactionSearch_cases_tab_dataGridContainer`}
          >
            <DataGrid
              classes={{ root: classes.root }}
              rows={rowData}
              columns={isSmView ? mobileViewColumns : defaultCols}
              rowHeight={40}
              getRowId={(row) => row?.id}
              pageSize={10}
              headerHeight={40}
              checkboxSelection
              onSelectionModelChange={handleSelectionChange}
              selectionModel={selectedIds}
              // autoHeight
              disableSelectionOnClick
              pagination
              rowsPerPageOptions={[5, 10, 25]}
              getRowClassName={(params: any) => `styledrows`}
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  color: '#3F5C69',
                  fontWeight: '600',
                  fontSize: '12px',
                  fontFamily: 'Open Sans',
                },
              }}
            />
          </CcfBox>
        </CcfBox>
      </CcfBox>
    </CcfBox>
  );
}

export default CcfInteractionSearchCasesTab;
